import actions from './actions'
import types from './constants'
import services from '../../services/progress'
import { generateProgressReport } from '../../util/generators/generateProgressReport';
import { generateProgressReportTrendline } from '../../util/generators/generateTrendline';
import { getTotalSeconds } from '../../util/getTotalSeconds';
import { shouldFilterStoryFromReport } from '../../../../services/EarlyReaderService';
import { fetchStudentTrends } from '../../util/generators/generateClassProgressReport';
import { LOCALE_OPTIONS } from '../../../../services/badging/constants';
import { localesUnderscoreMap } from '../../../../constants/constants';

const progressSelect = (selection) => (dispatch) => {
  dispatch(actions[types.PROGRESS_SELECT](selection))
}

const fetchReport = (student, metric, scale, benchmark, customBenchmarks, equating, locale, additionalProps, selectedStatePercentileCuts) => async (dispatch) => {
  dispatch(actions[types.PROGRESS_PENDING]())
  try {
    const [report, activities] = await services.fetchReport(student, metric, scale, benchmark, customBenchmarks, equating, locale, additionalProps, selectedStatePercentileCuts);
    const studentObjectForTrend = [{id: student.value, grade: student.grade}];
    const language = LOCALE_OPTIONS.find(i => i.value === localesUnderscoreMap[locale])?.label;
    const trends = await fetchStudentTrends(studentObjectForTrend, language);
    report.trend = trends?.[0]?.trend; // it returns only the one student we requested
    dispatch(actions[types.PROGRESS_COMPLETE](report, activities));
  }catch(e){
    console.error("Error fetching report or student trends:", e);
    dispatch(actions[types.PROGRESS_ERROR](e.message));
  }
}

const scaleReport = (activities, metric, scale, benchmark, student, customBenchmarks,locale, selectedStatePercentileCuts) => (dispatch) => {
  if(activities && activities.length > 0) {
    let report = generateProgressReport(activities, metric, scale, benchmark, customBenchmarks, locale, selectedStatePercentileCuts);
    report = accountForTrendline(report, scale, student, locale);
    dispatch(actions[types.PROGRESS_UPDATED](report, activities));
  }
};

// Shift goodCutoff by a constant, and change yMax if warrented once the trendline is generated
export function accountForTrendline(report, scale, student,locale) {
  if(report && report.data && report.data.length > 0) {
    // filter out early reader activities and short audio activities
    const reportDataFiltered = report.data.filter((data) => {

      const totalSeconds = getTotalSeconds(data.timeRead);

      // return false if short audio activity
      if (totalSeconds < 30) return false;

      // return false if early reader is true
      if (data.storyTags && shouldFilterStoryFromReport(data, scale)) return false;

      return true;
    })
    if (reportDataFiltered[0]) report.trendline = generateProgressReportTrendline(reportDataFiltered, scale, student && student.grade,locale);
    if(report && report.trendline && report.trendline.length > 0) {
      let trendMax = report.trendline[report.trendline.length - 1][1] * 1.1;
      if(trendMax > report.yMax) {
        let difference = trendMax - report.yMax;
        report.yMax = trendMax;
        report.greatCutoff = report.greatCutoff.map(cutoff => {
          cutoff[1] = cutoff[1] + difference;
          return cutoff;
        });
      }
    }
  }
  return report;
}

export default {
  progressSelect,
  fetchReport,
  scaleReport,
}
